import { useTranslation } from 'next-i18next';
import React from 'react';

import {
  CreatePassword,
  ForgotPassword,
  Login,
  LoginInvitation,
  LoginOTP,
  ResetPassword,
  Signup,
} from '@/modules/auth';
import { IAuthTypes } from '@/modules/auth/context';
import LanguageSelector from '@/shared/components/atoms/LanguageSelector';

import AydiLogoAR from '~/svg/logoARHorizontel.svg';
import AydiLogo from '~/svg/LogoHorizontelEN.svg';

const FormsContainer: React.FC<{
  authType: IAuthTypes;
}> = ({ authType }) => {
  const {
    i18n: { language },
  } = useTranslation('login');

  return (
    <div className='align-center relative row-span-2 flex  h-full w-full flex-col items-center justify-center'>
      <div className='absolute right-16 top-24 desktop:right-30'>
        <LanguageSelector useName />
      </div>

      <div className='flex w-full flex-col px-20 desktop:px-125'>
        {/* ***************** Aydi logo in ar and en ************** */}
        <span className='text-[7.5rem] text-primary-default'>
          {language === 'ar' ? <AydiLogoAR /> : <AydiLogo />}
        </span>
        {authType === IAuthTypes.login && <Login />}
        {authType === IAuthTypes.signup && <Signup />}
        {authType === IAuthTypes.forgotPassword && <ForgotPassword />}
        {authType === IAuthTypes.createPassword && <CreatePassword />}
        {authType === IAuthTypes.resetPassword && <ResetPassword />}
        {authType === IAuthTypes.loginOTP && <LoginOTP />}
        {authType === IAuthTypes.loginInvitation && <LoginInvitation />}
      </div>
    </div>
  );
};

export default FormsContainer;
